var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"spectrum-Icon",class:[("spectrum-Icon--size" + _vm.sizeLetter)],attrs:{"aria-label":_vm.name}},[_c('use',{attrs:{"xlink:href":("#spectrum-icon-" + _vm.sizePx + "-" + (_vm.camelize(_vm.name)))}})])}
var staticRenderFns = []

export { render, staticRenderFns }